<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Discount name -->
    <discount-name-field
      v-model="$attrs.discount.name"
      :error="$attrs.errors.discount.name"
    />

    <!-- Amount -->
    <amount-field
      v-model="$attrs.discount.amount"
      :error="$attrs.errors.discount.amount"
    />

    <!-- Start date -->
    <start-date-field
      v-model="$attrs.discount.start_date"
      :error="$attrs.errors.discount.start_date"
    />

    <!-- End date -->
    <end-date-field
      v-model="$attrs.discount.end_date"
      :error="$attrs.errors.discount.end_date"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import discountNameField from '@/components/forms/discount/fields/DiscountName'
import amountField from '@/components/forms/discount/fields/Amount'
import startDateField from '@/components/forms/discount/fields/StartDate'
import endDateField from '@/components/forms/discount/fields/EndDate'

export default {
  name: 'discount-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    discountNameField,
    amountField,
    startDateField,
    endDateField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// DiscountBlankForm.vue?7107008a